import { Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import { ActionCooldownService } from '../services/action-cooldown.service';

@Directive({ selector: '[cooldownBubble]', standalone: true })
export class CooldownBubbleDirective implements OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private cooldown = inject(ActionCooldownService);
  private bubble: HTMLElement | null = null;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    const host = this.el.nativeElement;
    host.addEventListener('click', this.onClick);
  }

  ngOnDestroy(): void {
    this.el.nativeElement.removeEventListener('click', this.onClick);
    this.removeBubble();
    if (this.hideTimer) clearTimeout(this.hideTimer);
  }

  private onClick = (): void => {
    const key = this.el.nativeElement.getAttribute('data-cooldown-key');
    if (!key) return;
    if (!this.cooldown.isCoolingDown(key)) return;
    this.showBubble();
  };

  private showBubble(): void {
    this.removeBubble();
    const host = this.el.nativeElement;
    const rect = host.getBoundingClientRect();
    const bubble = document.createElement('div');
    bubble.textContent = 'Espere un momento antes de volver a intentar';
    Object.assign(bubble.style, {
      position: 'fixed',
      left: `${rect.left + rect.width / 2}px`,
      top: `${rect.top - 8}px`,
      transform: 'translateX(-50%) translateY(-100%)',
      background: '#1e293b',
      color: '#f1f5f9',
      padding: '6px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      lineHeight: '1.4',
      whiteSpace: 'nowrap',
      zIndex: '99999',
      pointerEvents: 'none',
      boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
      opacity: '0',
      transition: 'opacity 0.15s ease',
    });
    document.body.appendChild(bubble);
    this.bubble = bubble;
    requestAnimationFrame(() => { bubble.style.opacity = '1'; });
    this.hideTimer = setTimeout(() => this.removeBubble(), 2500);
  }

  private removeBubble(): void {
    if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null; }
    if (this.bubble) {
      this.bubble.remove();
      this.bubble = null;
    }
  }
}
